if (!customElements.get('facet-clear')) {
  class FacetClear extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const parentFilter = this.closest('.facets__disclosure');
      if (!parentFilter) return;

      const inputs = parentFilter.querySelectorAll('input:checked');
      const allInput = parentFilter.querySelector('[js-all]');

      if (allInput && allInput.checked) {
        allInput.checked = false;
      }

      inputs.forEach((filter) => {
        if (!allInput?.checked && filter != allInput && filter.checked)
          return filter.click();
      });
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('facet-clear', FacetClear);
}
